<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div id="data-list-thumb-view" class="data-list-container">
      <vx-card title="Data de busca">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
            <h6 class="mb-2">Data Inicial</h6>
            <div>
              <datepicker
                placeholder="Selecione a Data Inicial"
                :language="languages['ptBR']"
                format="dd/MM/yyyy"
                v-model="startDate"
              ></datepicker>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
            <h6 class="mb-2">Data Final</h6>
            <div>
              <datepicker
                placeholder="Selecione a Data Final"
                :language="languages['ptBR']"
                format="dd/MM/yyyy"
                v-model="endDate"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="vx-row"></div>
        <br />
        <vs-button color="success" type="filled" @click="getOrdersByPeriod()"
          >Buscar</vs-button
        >
      </vx-card>
      <br />
      <br />
    </div>
    <div>
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            @click="$router.push(`/${path}/novo-pedido`).catch((err) => {})"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success"
            >Novo</vs-button
          >
        </div>
      </div>
      <vue-good-table
        ref="my-table"
        selectionInfoClass="mytable"
        style="width: 100%"
        styleClass="vgt-table condensed"
        :search-options="{
          enabled: true,
          trigger: '',
          placeholder: 'Procurar',
          skipDiacritics: true,
        }"
        :pagination-options="paginationOptions"
        :columns="columns"
        :rows="getOrders"
        @on-row-click="onRowClick"
      >
        <div slot="emptystate" class="text-center">
          Nenhum resultado encontrado
        </div>
        <template slot="table-row" slot-scope="order">
          <span class="font-medium" v-if="order.column.field == 'idOrder'">
            <vs-chip :color="color">{{ order.row.idOrder }}</vs-chip>
          </span>
          <span
            class="font-medium"
            v-if="order.column.field == 'corporateName'"
            @click.stop="edit(order.row.idOrder)"
          >
            {{ order.row.corporateName }}
          </span>
          <span class="font-medium" v-if="order.column.field == 'stage'">
            <div v-if="order.row.stage == 'Conferência'">
              <vs-button
                @click.stop="openStage(order.row.idOrder)"
                color="#1E90FF"
                type="flat"
                >{{ order.row.stage }}</vs-button
              >
            </div>
            <div v-show="order.row.stage == 'Faturamento'">
              <vs-button
                @click.stop="openStage(order.row.idOrder)"
                color="success"
                type="flat"
                >{{ order.row.stage }}</vs-button
              >
            </div>
            <div v-if="path == 'equipamentos'">
              <div v-show="order.row.stage == 'Instalado'">
                <vs-button
                  @click.stop="openStage(order.row.idOrder)"
                  color="warning"
                  type="flat"
                  >{{ order.row.stage }}</vs-button
                >
              </div>
            </div>
            <div v-else>
              <div v-show="order.row.stage == 'Estoque'">
                <vs-button
                  @click.stop="openStage(order.row.idOrder)"
                  color="warning"
                  type="flat"
                  >{{ order.row.stage }}</vs-button
                >
              </div>
            </div>
            <div v-show="order.row.stage == 'Concluído'">
              <vs-button
                @click.stop="openStage(order.row.idOrder)"
                color="primary"
                type="flat"
                >{{ order.row.stage }}</vs-button
              >
            </div>
          </span>
          <span class="font-medium" v-if="order.column.field == 'dateOrder'">
            {{ order.row.dateOrder }}
          </span>
          <span class="font-medium" v-if="order.column.field == 'totalOrder'">
            {{ order.row.totalOrder }}
          </span>
          <span class="font-medium" v-if="order.column.field == 'orderType'">
            <vs-chip :color="color">
              {{ order.row.orderType }}
            </vs-chip>
          </span>
          <span class="font-medium" v-if="order.column.field == 'photo'">
            <!--{{ order.row.userName }}-->
            <vx-tooltip :text="order.row.userName" position="left">
              <vs-avatar
                :src="order.row.photo"
                size="30px"
                class="border-2 border-white border-solid -m-1"
              ></vs-avatar>
            </vx-tooltip>
          </span>
          <span v-if="order.column.field === 'action'">
            <div align="center">
              <vs-dropdown vs-custom-content vs-trigger-click>
                <a
                  class="flex items-center"
                  style="font-weight: 500; font-size: 1rem"
                  href="#"
                >
                  Mais <i class="material-icons"> expand_more </i>
                </a>
                <vs-dropdown-menu class="w-48">
                  <vs-dropdown-item @click.stop="open(order.row.idOrder)">
                    <font-awesome-icon :icon="['fa', 'search']" class="w-4" />
                    Visualizar
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      download(order.row.idOrder, order.row.corporateName)
                    "
                    ><font-awesome-icon
                      :icon="['far', 'file-pdf']"
                      class="w-4"
                    />
                    Download
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="duplicate(order.row.idOrder)"
                    ><font-awesome-icon :icon="['fas', 'copy']" class="w-4" />
                    Duplicar
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    divider
                    @click="showPoupUp(order.row.idOrder)"
                  >
                    <font-awesome-icon
                      :icon="['far', 'trash-alt']"
                      class="w-4"
                    />
                    Excluir
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </span>
        </template>
      </vue-good-table>
      <vs-popup class="Confirmar" title="Remover" :active.sync="popupActive">
        <p>Tem certeza que deseja remover esse item para lixeira?</p>
        <div class="vx-row">
          <div class="vx-col w-full mt-5">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash-2"
              @click="deleteData()"
              class="float-right"
              >Remover</vs-button
            >
          </div>
        </div>
      </vs-popup>
    </div>
    <OrderReport ref="orderReport"></OrderReport>
  </div>
</template>
 
<script>
import { baseApiUrl } from "@/global";
import OrderReport from "../report/orderReport";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import router from "@/router";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { momentJS } from "@/helpers";
export default {
  components: {
    OrderReport,
    VueGoodTable,
    Datepicker,
  },
  props: {
    path: {
      type: String,
    },
  },
  data() {
    return {
      orders: [],
      startDate: null,
      endDate: null,
      languages: lang,
      selected: [],
      isMounted: false,
      color: null,
      action: null,
      dispatch: null,
      urlApi: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
      popupActive: false,
      idDelete: null,
    };
  },
  computed: {
    getOrders() {
      let orders;
      if (this.path == "suprimentos") {
        orders = _.cloneDeep(this.$store.state.supplies.suppliesOrdersFiltered);
        this.color = "#1E90FF";
        this.action = "supplies/trashFilteredSuppliesOrder";
        this.dispatch = "supplies/fetchSuppliesOrderByPeriod";
        this.urlApi = "suppliesOrder";
      }
      if (this.path == "equipamentos") {
        orders = _.cloneDeep(this.$store.state.equipments.equipmentOrdersFiltered);
        this.color = "success";
        this.action = "equipments/trashFilteredEquipmentOrder";
        this.dispatch = "equipments/fetchEquipmentOrderByPeriod";
        this.urlApi = "equipmentOrder";
      }
      if (this.path == "pecas") {
        orders = _.cloneDeep(this.$store.state.parts.partsOrdersFiltered);
        this.color = "danger";
        this.action = "parts/trashFilteredPartsOrder";
        this.dispatch = "parts/fetchPartsOrderByPeriod";
        this.urlApi = "partsOrder";
      }
      if (this.path == "mao-de-obra") {
        orders = _.cloneDeep(this.$store.state.labor.laborOrdersFiltered);
        this.color = "warning";
        this.action = "labor/trashFilteredLaborOrder";
        this.dispatch = "labor/fetchLaborOrderByPeriod";
        this.urlApi = "laborOrder";
      }
      return orders;
    },
  },
  methods: {
    async getOrdersByPeriod() {
      let payload = {
        loading: this.$vs.loading,
        notify: this.$vs.notify,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
        userGroup: this.$store.state.user.userGroup,
      };
      if (this.path == "equipamentos") {
        this.color = "success";
        this.action = "equipments/trashFilteredEquipmentOrder";
        this.urlApi = "equipmentOrder";
        await this.$store.dispatch("equipments/fetchEquipmentOrderByPeriod", payload);
      } else if (this.path == "suprimentos") {
        this.color = "#1E90FF";
        this.action = "supplies/trashFilteredSuppliesOrder";
        this.urlApi = "suppliesOrder";
        await this.$store.dispatch("supplies/fetchSuppliesOrderByPeriod",payload);
      } else if (this.path == "pecas") {
        this.color = "danger";
        this.action = "parts/trashFilteredPartsOrder";
        this.urlApi = "partsOrder";
        await this.$store.dispatch("parts/fetchPartsOrderByPeriod", payload);
      } else if (this.path == "mao-de-obra") {
        this.color = "warning";
        this.action = "labor/trashFilteredLaborOrder";
        this.urlApi = "laborOrder";
        await this.$store.dispatch("labor/fetchLaborOrderByPeriod", payload);
      } else {
        console.log("No path defined");
      }
    },
    async showPoupUp(idOrder) {
      this.popupActive = true;
      this.idDelete = idOrder;
    },
    async open(idOrder) {
      this.$refs.orderReport.open(idOrder, this.path);
    },
    edit(idOrder) {
      this.$router.push(`/${this.path}/editar/${idOrder}`).catch((err) => {});
    },
    async duplicate(idOrder) {
      try {
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/${this.urlApi}/duplicate`,
          { idOrder }
        );
      } catch (error) {
        console.log(error.response.data);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema ao duplicar",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
      let payload = {
        loading: this.$vs.loading,
        type: "completed",
        userGroup: this.$store.state.user.userGroup,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
      };
      if (this.path == "equipamentos") {
      await this.$store.dispatch("equipments/fetchEquipmentOrderByPeriod", payload);
    } else if (this.path == "suprimentos") {
      await this.$store.dispatch("supplies/fetchSuppliesOrderByPeriod",payload);
    } else if (this.path == "pecas") {
      await this.$store.dispatch("parts/fetchPartsOrderByPeriod", payload);
    } else if (this.path == "mao-de-obra") {
      await this.$store.dispatch("labor/fetchLaborOrderByPeriod", payload);
    } else {
      console.log("No path defined");
    }
    },
    async deleteData() {
      console.log(this.path)
      let payload = {
        idOrder: this.idDelete,
        loading: this.$vs.loading,
        notify: this.$vs.notify,
      };
      await this.$store.dispatch(this.action, payload);
      this.popupActive = false;
    },
    async download(idOrder, corporateName) {
      this.$refs.orderReport.download(idOrder, this.path, corporateName);
    },
    openStage(idOrder) {
      this.$router.push(`/etapa-${this.path}/${idOrder}`).catch((err) => {});
    },
    onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idOrder",
          tdClass: "align-middle",
        },
        {
          label: "Cliente",
          field: "corporateName",
          tdClass: "align-middle",
        },
        {
          label: "Processo",
          field: "stage",
          tdClass: "align-middle",
        },
        {
          label: "Data",
          field: "dateOrder",
          type: "date",
          dateInputFormat: "dd/MM/yyyy",
          dateOutputFormat: "dd/MM/yyyy",
          tdClass: "align-middle",
        },
        {
          label: "Valor",
          field: "totalOrder",
          tdClass: "align-middle",
        },
        {
          label: "Tipo",
          field: "orderType",
          tdClass: "align-middle",
        },
        {
          label: "Consultor",
          field: "photo",
          tdClass: "align-middle",
        },
        {
          label: "Ações",
          field: "action",
          tdClass: "align-middle",
        },
      ];
    },
  },
  async created() {
    console.log(this.path);
    this.moment = momentJS();
    const firstAndLastDate = this.moment.getFirstAndLastDayOfMonth();
    this.startDate = firstAndLastDate.firstDay;
    this.endDate = firstAndLastDate.lastDay;
    let payload = {
      loading: this.$vs.loading,
      notify: this.$vs.notify,
      data: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
      userGroup: this.$store.state.user.userGroup,
    };
    if (this.path == "equipamentos") {
      await this.$store.dispatch("equipments/fetchEquipmentOrderByPeriod", payload);
    } else if (this.path == "suprimentos") {
      await this.$store.dispatch("supplies/fetchSuppliesOrderByPeriod",payload);
    } else if (this.path == "pecas") {
      await this.$store.dispatch("parts/fetchPartsOrderByPeriod", payload);
    } else if (this.path == "mao-de-obra") {
      await this.$store.dispatch("labor/fetchLaborOrderByPeriod", payload);
    } else {
      console.log("No path defined");
    }

    this.mountTable();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
